import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase'
import config from './firebaseRef'

firebase.initializeApp(config)

const userRef = firebase.database().ref('user')
async function checkUserProfile ({uid, email}) {
  let snapshot = await userRef.once('value')
  // .then(snapshot => {
  // })
  if (!snapshot.hasChild(uid)) {
    userRef.child(uid).set({
      role: 'vendor',
      email
    })
  } else {
    let userProfileRef = await userRef.child(uid).once('value')
    console.log(userProfileRef.val())
    store.dispatch('userProfile', userProfileRef.val())
  }
}

firebase.auth().onAuthStateChanged(user => {
  if (user) {
    // login success fires
    console.log(user)
    checkUserProfile(user)
  }
  store.dispatch('user', user || {})
  // initial no log and loging-out fire
  store.dispatch('authed', user !== null)
})

const AUTH_STATE_AUTHING = 0
const AUTH_STATE_NOAUTH = 1
export const AUTH_STATE_AUTHED = 2
const storedState = {
  authState: AUTH_STATE_AUTHING,
  user: {},
  firmware: {
    category: '',
    custom: ''
  },
  isMibFilterStoreEmpty: true,
  mibFliterStore: {
    category: '',
    custom: '',
    model: '',
    family: ''
  }
}
const mutations = {
  authed (state, authed) {
    state.authState = authed ? AUTH_STATE_AUTHED : AUTH_STATE_NOAUTH
  },
  user (state, content) {
    state.user = {
      email: content.email
    }
  },
  userProfile (state, profile) {
    state.user = {
      ...state.user,
      ...profile
    }
  },
  mibInfoSelected (state, mibInfo) {
    console.log('mutation mibInfoSelected')
    // console.log(mibInfo)
    state.mibFliterStore = mibInfo
    state.isMibFilterStoreEmpty = false
    console.log(state.mibFliterStore)
  },
  deleteMibFilterInfo (state) {
    state.mibFliterStore = {
      category: '',
      custom: '',
      model: '',
      family: ''
    }
    state.isMibFilterStoreEmpty = true
    console.log('deleteMibFilterInfo')
  },
  firmwareInfoSelected (state, firmwareInfo) {
    state.firmware = {
      ...state.firmware,
      ...firmwareInfo
    }
  },
  firmwareInfoDelete (state) {
    state.firmware = {
      ...state.firmware,
      ...{
        category: '',
        custom: ''
      }
    }
  }
}

Vue.use(Vuex)
export const store = new Vuex.Store({
  state: storedState,
  mutations,
  strict: process.env.NODE_ENV !== 'production'
})

export function login (...arg) {
  return firebase.auth().signInWithEmailAndPassword(...arg)
}

export function resetPassword (mail) {
  return firebase.auth().sendPasswordResetEmail(mail)
}

export function firebaseLogout () {
  return firebase.auth().signOut()
}

function delay (sec = 1) {
  if (sec > 10) return console.log('delay cannot bigger than 10s')
  return new Promise(resolve => {
    setTimeout(resolve, sec * 1000)
  })
}

export async function getAuthState () {
  // eslint-disable-next-line
  while (storedState.authState === AUTH_STATE_AUTHING) {
    await delay(1)
    console.log('waiting auth')
  }
  return storedState.authState === AUTH_STATE_AUTHED
}

export function getFireBase () {
  return firebase
}

export function getFirmwareRef () {
  return firebase.database().ref('firmware')
}

export function getFwSwitchRef () {
  return firebase.database().ref('firmware/switch/storage')
}

export function getNetworkModelRef () {
  return firebase.database().ref('network/model')
}

export function getNetworkFamilyRef () {
  return firebase.database().ref('network/family')
}

export function getNetworkProductionRef () {
  return firebase.database().ref('network/product')
}

export function getFWPiRef () {
  return firebase.database().ref('firmware/pi/storage')
}

export function getSwitchRef () {
  return firebase.database().ref('switch/registeration')
}

export function getSwitchHistory () {
  return firebase.database().ref('switch/history')
}

export function getSmartCtrlRef () {
  return firebase.database().ref('smart-controller/registeration')
}

export function getSmartCtrlHistory () {
  return firebase.database().ref('smart-controller/history')
}

export function getSmartCtrlActRef () {
  return firebase.database().ref('smart-controller/registerationChange')
}

export function getPMIB () {
  return firebase.database().ref('private-mib')
}

export function getModelForUI (model) {
  switch (model) {
    case 'ite':
      return 'ITE'
    case 'iteHome':
      return 'ITE Home'
    case 'aspeed':
      return 'Aspeed'
  }
}

export function getCustomForUI (custom) {
  switch (custom) {
    case 'gomax':
      return 'GoMax'
    case 'gofanco':
      return 'Gofanco'
    case 'general':
      return 'General'
    case 'lantech':
      return 'Lantech'
    case 'turkey':
      return 'Turkey'
    case '21net':
      return '21net'
    case 'germany':
      return 'Germany'
    case 'canada':
      return 'Canada'
    case 'hytec':
      return 'Hytec'
    case 'lgu+':
      return 'LGU+'
    case 'ruf':
      return 'Ruf'
    case 'ltdp':
      return 'Ltdp'
    case 'tekdis':
      return 'Tekdis'
    case 'acrobel':
      return 'Acrobel'
    case 'intrising':
      return 'Intrising'
    case 'trafsys':
      return 'Trafsys'
  }
}

export function getCustomFromLabel (custom) {
  switch (custom) {
    case 'GoMax':
      return 'gomax'
    case 'Gofanco':
      return 'gofanco'
    case 'General':
      return 'general'
    case 'Lantech':
      return 'lantech'
    case 'Turkey':
      return 'turkey'
    case '21net':
      return '21net'
    case 'Germany':
      return 'germany'
    case 'Canada':
      return 'canada'
    case 'Hytec':
      return 'hytec'
    case 'LGU+':
      return 'lgu+'
    case 'Ruf':
      return 'ruf'
    case 'Ltdp':
      return 'ltdp'
    case 'Tekdis':
      return 'tekdis'
    case 'Acrobel':
      return 'acrobel'
    case 'Intrising':
      return 'intrising'
  }
}

export function getCategoryFromLabel (custom) {
  // watch out here required Production Category mapping to Firmware Category
  switch (custom) {
    case 'Switch1':
      return 'swix1'
    case 'Switch2':
      return 'swix2'
    case 'Wireless':
      return 'wrouter'
    case 'Router':
      return 'router'
    case 'Router X':
      return 'routerx'
  }
}

export const filterOptions = {
  production: {
    category: [
      {label: 'Switch1', value: 'Switch1'},
      {label: 'Switch2', value: 'Switch2'},
      {label: 'Wireless', value: 'Wireless'},
      {label: 'Router', value: 'Router'},
      {label: 'Router X', value: 'Router X'}
    ],
    custom: [
      {label: 'Lantech', value: 'Lantech'},
      {label: 'Turkey', value: 'Turkey'},
      {label: '21net', value: '21net'},
      {label: 'Germany', value: 'Germany'},
      {label: 'Canada', value: 'Canada'},
      {label: 'Hytec', value: 'Hytec'},
      {label: 'LGU+', value: 'LGU+'},
      {label: 'Ruf', value: 'Ruf'},
      {label: 'Ltdp', value: 'Ltdp'},
      {label: 'Tekdis', value: 'Tekdis'},
      {label: 'Acrobel', value: 'Acrobel'},
      {label: 'Intrising', value: 'Intrising'},
      {label: 'Trafsys', value: 'Trafsys'},
      {label: 'Undefined', value: 'Undefined'}
    ],
    status: [
      {label: 'Production', value: 'Production'},
      {label: 'Develop', value: 'Develop'},
      {label: 'Sample', value: 'Sample'}
    ]
  },
  firmware: {
    category: [
      {label: 'Switch1', value: 'swix1'},
      {label: 'Switch2', value: 'swix2'},
      {label: 'Wireless', value: 'wrouter'},
      {label: 'Router', value: 'router'},
      {label: 'RouterX', value: 'routerx'}
    ],
    custom: [
      {label: 'Lantech', value: 'lantech'},
      {label: 'Turkey', value: 'turkey'},
      {label: '21net', value: '21net'},
      {label: 'Germany', value: 'germany'},
      {label: 'Canada', value: 'canada'},
      {label: 'Hytec', value: 'hytec'},
      {label: 'LGU+', value: 'lgu+'},
      {label: 'Ruf', value: 'ruf'},
      {label: 'Ltdp', value: 'ltdp'},
      {label: 'Tekdis', value: 'tekdis'},
      {label: 'Acrobel', value: 'acrobel'},
      {label: 'Intrising', value: 'intrising'},
      {label: 'Trafsys', value: 'trafsys'},
      {label: 'Undefined', value: 'undefined'}
    ],
    status: [
      {label: 'Release', value: 'release'},
      {label: 'Develop', value: 'dev'},
      {label: 'Beta', value: 'beta'},
      {label: 'Disabled', value: 'disabled'}
    ]
  }
}

export const naturalSorting = (data, key, option = 'asc') => {
  return option === 'asc'
    ? data.slice().sort((a, b) => a[key].replace(' ', '').localeCompare(b[key].replace(' ', ''), undefined, {numeric: true}))
    : data.slice().sort((a, b) => b[key].replace(' ', '').localeCompare(a[key].replace(' ', ''), undefined, {numeric: true}))
}



// WEBPACK FOOTER //
// ./src/index.js